module.exports = __webpack_public_path__ + "static/img/logo.e05139a4.svg";